import { ActionType, createStandardAction } from 'typesafe-actions';
import { TreeMapData } from '../../types/TreeMapData';

export const landingPageActions = {
  getTreeMapData: createStandardAction('@landingPage_treeMap/GET')(),
  addTreeMapData: createStandardAction('@landingPage_treeMap/ADD')<TreeMapData>(),
};

export type LandingPageActions = ActionType<typeof landingPageActions>;
